import script from "./index.vue?vue&type=script&lang=jsx&setup=true"
export * from "./index.vue?vue&type=script&lang=jsx&setup=true"

import "./index.vue?vue&type=style&index=0&id=4019acc4&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4019acc4"]])

export default __exports__